<template>
  <div class="sign-management-page">
    <!-- <section class="sign-stats-grid">
      <article class="stat-card">
        <div class="stat-title">在约达人</div>
        <div class="stat-value dark">{{ contractStats.active }}</div>
        <div class="stat-note green">+{{ contractStats.monthNew }} 本月新增</div>
      </article>
      <article class="stat-card">
        <div class="stat-title">即将到期（30天内）</div>
        <div class="stat-value orange">{{ contractStats.nearExpired }}</div>
        <div class="stat-note orange">需尽快处理续约</div>
      </article>
      <article class="stat-card">
        <div class="stat-title">已过期</div>
        <div class="stat-value dark">{{ contractStats.expired }}</div>
        <el-button type="text" size="mini" @click="viewExpired">查看</el-button>
      </article>
      <article class="stat-card">
        <div class="stat-title">已解约达人</div>
        <div class="stat-value red">{{ contractStats.fired }}</div>
      </article>
    </section> -->

    <section class="sign-list-header">
      <div class="sign-list-title">
        <span class="sign-list-kicker">签约管理</span>
        <h1>签约信息</h1>
        <p>管理红人签约状态、合同周期、分组和续约操作</p>
      </div>
      <div class="sign-list-status-card">
        <span>当前结果</span>
        <strong>{{ pageData.total || 0 }}</strong>
        <em>每页 {{ pageData.page_size }} 条</em>
      </div>
    </section>

    <section class="sign-filter-panel">
      <div class="sign-filter-row">
        <el-form :inline="true" :model="searchCondition" class="sign-filter-form" label-position="right">
          <el-form-item>
            <el-select
              v-model="searchCondition.sign_status"
              placeholder="签约状态"
              clearable
              class="filter-status"
              @change="search">
              <el-option label="在约" value="Y" />
              <el-option label="解约" value="N" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchCondition.date"
              type="daterange"
              start-placeholder="签约开始日期"
              end-placeholder="签约结束日期"
              range-separator="-"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              class="filter-date" />
          </el-form-item>
          <el-form-item>
            <SignatoryQuery
              v-model="searchCondition.signatory"
              :name="searchCondition.signatory"
              :showSet="false"
              class="filter-signatory"
              @handleSelect="handleSelect"
              @changeValue="changeSignatory" />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="searchCondition.nickname"
              placeholder="红人昵称"
              clearable
              class="filter-nickname"
              @change="search" />
          </el-form-item>
          <el-form-item>
            <select-sign-type
              :value.sync="searchCondition.sign_type"
              class="filter-sign-type"
              @change="search" />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-search"
              @click="handleQuery"
              :loading="loadingStatus"
              :disabled="loadingStatus">
              搜索
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              v-if='userPermissions.indexOf("artist_payment_list") > -1'
              size="mini"
              icon="el-icon-bank-card"
              @click='jumpToPage("artist_payment")'>
              导入结算信息
            </el-button>
            <ml-import v-if='userPermissions.indexOf("sign_enter_page") > -1' module="SIGN_RECORD" />
          </el-form-item>
          <el-form-item v-if='userPermissions.indexOf("sign_privacy_list") > -1'>
            <el-button type="success" size="mini" @click="openDialog">签约真实信息</el-button>
          </el-form-item>
          <el-form-item v-if="userPermissions.indexOf('sign_info_export') !== -1">
            <el-button
              type="primary"
              plain
              icon="el-icon-download"
              :loading="exportLoading"
              @click="exportData">
              {{ exportLoading ? '导出中...' : '导出' }}
            </el-button>
          </el-form-item>
        </el-form>
        <el-button
          v-if='userPermissions.indexOf("sign_enter_page") > -1'
          class="filter-create-button"
          type="primary"
          size="mini"
          icon="el-icon-plus"
          @click='jumpToPage("sign_create")'>
          新建签约
        </el-button>
      </div>
    </section>

    <MlPageTable
      class="sign-contract-table"
      :loading-status.sync="loadingStatus"
      :all-columns="defaultColumns"
      :table-name="tableName"
      :data-list="dataList"
      :limit.sync="pageData.page_size"
      :page.sync="pageData.current_page"
      :total.sync="pageData.total"
      :offset="pageData.offset"
      :show-index="true"
      highlight-current-row
      border
      @sort-change="changeTableSort"
      @getList="getList">
      <template slot="nickname">
        <el-table-column label="红人昵称" align="center" prop="nickname" min-width="180" fixed show-overflow-tooltip>
          <template slot-scope="{row}">
            <span class="nickname-cell" @click="detailPage(row.id)">{{ row.nickname || '-' }}</span>
          </template>
        </el-table-column>
      </template>
      <template slot="sign_end">
        <el-table-column label="签约到期日期" align="center" prop="sign_end" min-width="170">
          <template slot-scope="{row}">
            <div class="deadline-cell">
              <span>{{ formatDateText(row.sign_end) }}</span>
              <span v-if="deadlineText(row)" :class="['deadline-note', deadlineClass(row)]">
                {{ deadlineText(row) }}
              </span>
            </div>
          </template>
        </el-table-column>
      </template>
      <template slot="sign_type_alias">
        <el-table-column label="签约类型" align="center" prop="sign_type" min-width="120">
          <template slot-scope="{row}">
            <span>{{ row.sign_type_alias || row.sign_type || '-' }}</span>
          </template>
        </el-table-column>
      </template>
      <template slot="sign_status_alias">
        <el-table-column label="签约状态" align="center" prop="sign_status" min-width="100" sortable="custom">
          <template slot-scope="{row}">
            <span :class="['status-text', statusClass(row)]">{{ statusText(row) }}</span>
          </template>
        </el-table-column>
      </template>
      <el-table-column label="红人标签" align="center" min-width="110">
        <template slot-scope="{row}">
          <div v-if="formatTag(row.tag_ids).length" class="tag-cell">
            <el-tag
              v-for="item in formatTag(row.tag_ids)"
              :key="item.value"
              size="mini"
              :type="item.type"
              effect="plain">
              {{ item.label }}
            </el-tag>
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="340">
        <template slot-scope="{row}">
          <div class="action-cell">
            <span><el-button plain size="mini" @click="detailPage(row.id)">详情</el-button></span>
            <span v-if='userPermissions.indexOf("sign_transfer_group") > -1'>
              <el-button plain size="mini" @click="handleTransfer(row)">转组</el-button>
            </span>
            <span v-if='row.sign_status === "Y"&&userPermissions.indexOf("sign_enter_page") > -1'>
              <el-button plain size="mini" @click="handleRenewal(row)">续约</el-button>
            </span>
            <span v-if='!isFired(row) && userPermissions.indexOf("sign_fired_page") > -1'>
              <el-button plain size="mini" @click="handleFired(row)">解约</el-button>
            </span>
            <span v-if='!isFired(row) && userPermissions.indexOf("sign_tag") > -1'>
              <el-button plain size="mini" @click="handleEditTag(row)">标签</el-button></span>
            <span v-if='row.sign_status === "N" && userPermissions.indexOf("sign_enter_page") > -1'>
              <el-button plain size="mini" @click="handleAgainSign(row)">二签</el-button>
            </span>
            <span v-if='userPermissions.indexOf("sign_enter_page") > -1'>
              <el-button
                plain
                size="mini"
                title="手动同步关联该红人到星广汇"
                :loading="syncLoadingId === row.id"
                @click="handleSyncToAd(row)">
                同步
              </el-button>
            </span>
          </div>
        </template>
      </el-table-column>
      <template slot="footer">
        <Tips class="sign-footer-tips" :data="tipsList" :is-show-all="false" />
      </template>
    </MlPageTable>

    <KolRenewal ref="refKolRenewal" @refresh="getList" />
    <DialogTag ref="refDialogTag" @handleSelected="handleChangeTags" />

    <el-dialog
      title="签约真实信息"
      :visible.sync="dialogVisible"
      width="900px"
      @close="closeDialog">
      <el-table
        v-loading="privacyLoading"
        :data="privacyList"
        border
        stripe
        max-height="500px">
        <template slot="empty">
          <div style="padding: 20px; color: #909399;">暂无数据</div>
        </template>
        <el-table-column prop="nickname" label="昵称" align="center" min-width="120" show-overflow-tooltip />
        <el-table-column prop="real_name" label="姓名" align="center" min-width="120" show-overflow-tooltip />
        <el-table-column prop="id_card" label="身份证" align="center" min-width="120" show-overflow-tooltip />
        <el-table-column prop="tel" label="手机号" align="center" min-width="120" show-overflow-tooltip />
        <el-table-column prop="address" label="地址" align="center" min-width="120" show-overflow-tooltip />
      </el-table>

      <div style="margin-top: 15px; text-align: right;">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :total="privacyPage.total"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="privacyPage.page_size"
          :current-page="privacyPage.current_page"
          @size-change="handlePrivacySizeChange"
          @current-change="handlePrivacyPageChange" />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FileSaver from 'file-saver'

import Tips from '@/components/Tips'
import SignatoryQuery from '@/pages/sign_info/components/SignatoryQuery'
import MlPageTable from '@/components/common/MlPageTable.vue'
import KolRenewal from '@/pages/sign_info/components/KolRenewal.vue'
import DialogTag from './DialogTag.vue'
import MlImport from '../../../components/MlImport/index.vue'
import SelectSignType from '../../../components/select/sign-type.vue'

export default {
  name: 'SignList',
  components: {
    SelectSignType,
    MlImport,
    KolRenewal,
    MlPageTable,
    Tips,
    SignatoryQuery,
    DialogTag
  },
  computed: {
    ...mapGetters(['userPermissions']),
    tagMap() {
      const map = {}
      this.tags.forEach((tag) => {
        map[tag.id] = tag.name
      })
      return map
    },
    contractStats() {
      const rows = this.dataList || []
      const currentMonth = this.currentMonthText()
      const activeRows = rows.filter(row => this.isActive(row))
      const firedRows = rows.filter(row => this.isFired(row))
      const nearRows = rows.filter(row => {
        const days = this.getDeadlineDays(row.sign_end)
        return !this.isFired(row) && days !== null && days >= 0 && days <= 30
      })
      const expiredRows = rows.filter(row => {
        const days = this.getDeadlineDays(row.sign_end)
        return !this.isFired(row) && days !== null && days < 0
      })
      const monthNewRows = rows.filter(row => String(row.sign_start || '').indexOf(currentMonth) === 0)

      return {
        active: this.summaryData.active !== null ? this.summaryData.active : activeRows.length,
        nearExpired: this.summaryData.nearExpired !== null ? this.summaryData.nearExpired : nearRows.length,
        expired: this.summaryData.expired !== null ? this.summaryData.expired : expiredRows.length,
        fired: this.summaryData.fired !== null ? this.summaryData.fired : firedRows.length,
        monthNew: this.summaryData.monthNew !== null ? this.summaryData.monthNew : monthNewRows.length
      }
    }
  },
  data() {
    return {
      orderSort: {sign_start: 'desc', id: 'desc'},
      tipsList: [
        '身份证只有签约部和总监及以上同时有权限',
        '分配结果为分配到某个组',
        '博主分成条件查看权限为总监及以上'
      ],
      accountSourceOptions: [
        { label: '组内提供微信', val: 'pwg' },
        { label: '自己寻找', val: 'fys' }
      ],
      signatoryOptions: [],
      searchCondition: {signatory: null, year: null, month: null, sign_status: 'Y', sign_type: null, date: null},
      summaryData: {
        active: null,
        nearExpired: null,
        expired: null,
        fired: null,
        monthNew: null
      },
      //筛选条件缓存key
      pageSearchKey:'page_search_key:sign_info',
      pageData: {
        total: 0,
        offset: 0,
        page_size: 15,
        current_page: 1
      },
      loadingStatus: false,
      exportLoading: false,
      syncLoadingId: null,
      dataList: [],
      defaultColumns: [
        { hide: false, prop: 'nickname', label: '红人昵称', width: 180, sortable: true, fixed: true, slot: true },
        { hide: false, prop: 'signatory', label: '签约人', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'sign_start', label: '首次签约日期', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'sign_end', label: '签约到期日期', width: 120, sortable: false, fixed: false, slot: true },
        { hide: false, prop: 'platform_name_aft', label: '签约后主平台', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'nature_alias', label: '合约性质', width: 90, sortable: false, fixed: false },
        { hide: false, prop: 'sign_type_alias', label: '签约类型', width: 120, slot: true },
        { hide: false, prop: 'group_name', label: '项目组', width: 120, sortable: false, fixed: false },
        { hide: false, prop: 'fired_at', label: '解约日期', width: 80, sortable: false, fixed: false },
        { hide: false, prop: 'fired_type_alias', label: '解约类型', width: 90, sortable: false, fixed: false },
        {
          hide: false,
          prop: 'sign_status_alias',
          label: '签约状态',
          width: 100,
          sortable: true,
          fixed: false,
          slot: true
        }
      ],
      tableName: 'sign_info_contract_dashboard',
      tags: [],
      showTagDialog: false,
      dialogVisible: false,
      privacyList: [],
      privacyLoading: false,
      privacyPage: {
        page_size: 10,
        current_page: 1,
        total: 0
      },
      formTag: { tag_ids: [], artist_id: null, nickname: '' }
    }
  },
  created() {
    this.initSignatoryOption()
    this.loadTagOptions()
    if (sessionStorage.getItem(this.pageSearchKey)) {
      this.searchCondition = JSON.parse(sessionStorage.getItem(this.pageSearchKey))
    }
    this.handleQuery()
  },
  async mounted() {
    // this.recordPageUsage()
    // await this.loadTagOptions()
    // setTimeout(async () => {
    //   await this.getList()
    // }, 100)
  },
  methods: {
    accountSourceFormat(row) {
      return this.selectDictLabel(this.accountSourceOptions, row.account_source)
    },
    selectDictLabel(datas, value) {
      const actions = []
      Object.keys(datas).map((key) => {
        if (datas[key].val === value) {
          actions.push(datas[key].label)
          return false
        }
      })
      return actions.join('')
    },
    changeTableSort({ prop, order }) {
      const orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.orderSort = orderSort
      this.getList()
    },
    async initSignatoryOption() {
      const { list } = await this.$api.getSignInfoSignatoryList()
      this.signatoryOptions = []
      list.forEach((item) => {
        this.signatoryOptions.push({ value: item.userid, label: item.name })
      })
    },
    async getList() {
      this.loadingStatus = true
      const pagingInfo = { page_size: this.pageData.page_size, current_page: this.pageData.current_page }
      const searchCondition = this.handleSearchCondition()
      const listParams = Object.assign({}, searchCondition, pagingInfo, { order: this.orderSort })
      this.dataList = []
      try {
        const listResp = await this.$api.getSignInfoList(listParams)
        const { list, pages, summary } = listResp || {}
        this.$nextTick(() => {
          this.dataList = list || []
        })
        this.pageData.total = pages ? pages.total : 0
        this.pageData.offset = pages ? pages.offset : 0
        this.applySummary(summary || {}, list || [], pages || {})
      } finally {
        this.loadingStatus = false
      }
    },
    normalizeOverviewData(response) {
      const source = response && typeof response === 'object'
        ? (response.data || response.info || response.summary || response.list || response.result || response)
        : {}

      if (source && typeof source === 'object' && !Array.isArray(source) && source.info && typeof source.info === 'object') {
        return source.info
      }

      if (Array.isArray(source)) {
        return source.length > 0 && typeof source[0] === 'object' ? source[0] : {}
      }

      return source && typeof source === 'object' ? source : {}
    },
    handleQuery(){
      this.pageData.current_page = 1
      this.getList()
      //缓存筛选条件，刷新后可以继续使用
      sessionStorage.setItem(this.pageSearchKey, JSON.stringify(this.searchCondition))
    },
    handleSearchCondition() {
      const condition = {}

      if (this.searchCondition.sign_status) {
        condition.sign_status = this.searchCondition.sign_status
      }
      if (this.searchCondition.year) {
        condition.year = this.searchCondition.year
      }
      if (this.searchCondition.month) {
        condition.month = this.searchCondition.month
      }

      if (this.searchCondition.signatory) {
        condition.signatory = this.searchCondition.signatory
      }
      if (this.searchCondition.nickname) {
        condition.nickname = this.searchCondition.nickname
      }
      if (this.searchCondition.sign_type) {
        condition.sign_type = this.searchCondition.sign_type
      }

      if (this.searchCondition.date && this.searchCondition.date.length === 2) {
        condition.start_date = this.searchCondition.date[0]
        condition.end_date = this.searchCondition.date[1]
      }

      return condition
    },
    detailPage(id) {
      this.$router.push({ name: 'sign_detail', params: { id: id } })
    },
    async exportData() {
      this.exportLoading = true
      try {
        const searchCondition = this.handleSearchCondition()
        const response = await this.$api.exportSignInfoList(searchCondition)
        const name = `签约信息-${searchCondition.year ? searchCondition.year + '年' : ''}${searchCondition.month ? searchCondition.month + '月' : ''}`

        this.saveExportXlsx(response, name)
      } catch (e) {
        this.exportLoading = false
        this.$message.warning('导出异常，请联系管理员')
      }
    },
    saveExportXlsx(response, title) {
      if (response && response.data && response.data instanceof Blob) {
        const isFileSaverSupported = !!new Blob
        if (isFileSaverSupported) {
          const data = response.data
          const contentType = response.headers['content-type']
          const blob = new Blob([data], {
            type: contentType
          })

          FileSaver.saveAs(blob, decodeURI(encodeURI(title) + '.xlsx'), { autoBom: true })
          setTimeout(() => {
            this.exportLoading = false
          }, 500)
        } else {
          this.exportLoading = false
          this.$message.warning('浏览器不支持导出文件')
        }
      } else {
        this.exportLoading = false
        this.$message.warning(response.msg || '导出异常')
      }
    },
    handleSelect(item) {
      this.searchCondition.signatory = item.value
      this.search()
    },
    async changeSignatory(val) {
      this.searchCondition.signatory = val
      this.search()
    },
    jumpToPage(pageName, params, query) {
      this.$router.push({
        name: pageName,
        params: params,
        query: query
      })
    },
    handleFired(row) {
      this.jumpToPage('sign_fired', null, {
        artist_id: row.id,
        nickname: row.nickname
      })
    },
    handleTransfer(row) {
      this.jumpToPage('transfer_group', null, {
        artist_id: row.id,
        nickname: row.nickname
      })
    },
    handleRenewal(row) {
      if (this.$refs.refKolRenewal) {
        this.$refs.refKolRenewal.show(row, 'renewal')
      } else {
        alert('无权限')
      }
    },
    handleAgainSign(row) {
      if (this.$refs.refKolRenewal) {
        this.$refs.refKolRenewal.show(row, 'again')
      } else {
        alert('无权限')
      }
    },
    // 手动同步关联：把该红人的签约信息同步到星广汇
    async handleSyncToAd(row) {
      try {
        await this.$confirm(
          `确认将【${row.nickname || ''}】的签约信息同步关联到星广汇？`,
          '同步星广汇',
          { type: 'warning', confirmButtonText: '确定同步', cancelButtonText: '取消' }
        )
      } catch (e) {
        return
      }
      this.syncLoadingId = row.id
      try {
        const { synced, msg, ad_nickname: adNickname } = await this.$api.syncSignInfoToAd({ artist_id: row.id }) || {}
        if (synced) {
          this.$message.success(adNickname ? `同步成功，已关联星广汇红人：${adNickname}` : (msg || '同步成功'))
        } else {
          this.$message.warning(msg || '同步失败，请联系管理员')
        }
      } catch (e) {
        // 业务异常提示由请求拦截器/后端 msg 统一处理
      } finally {
        this.syncLoadingId = null
      }
    },
    async loadTagOptions() {
      await this.$api.getTagOptions().then((resp) => {
        this.tags = [...resp.list]
      })
    },
    handleEditTag(row) {
      if (this.$refs.refDialogTag) {
        this.$refs.refDialogTag.open(row)
      }
    },
    handleChangeTags(formTag) {
      const index = this.dataList.findIndex(value => value.id === formTag.artist_id)
      if (index > -1) {
        this.dataList[index].tag_ids = formTag.tag_ids || []
      }
    },
    formatTag(tagIds) {
      if (tagIds) {
        return tagIds.map((tagId) => {
          return { label: this.tagMap[tagId], value: tagId, type: 'warning' }
        }).filter(item => item.label)
      }
      return []
    },
    async openDialog() {
      this.dialogVisible = true
      this.privacyPage.current_page = 1
      this.privacyLoading = true
      this.privacyList = []
      const { list, pages } = await this.$api.getSignPrivacyList({
        page_size: this.privacyPage.page_size,
        current_page: this.privacyPage.current_page
      })
      this.$nextTick(() => {
        this.privacyList = list
      })
      if (pages) {
        this.privacyPage.total = pages.total || 0
      }
      this.privacyLoading = false
    },
    closeDialog() {
      this.dialogVisible = false
    },
    handlePrivacyPageChange(page) {
      this.privacyPage.current_page = page
      this.fetchPrivacyList()
    },
    handlePrivacySizeChange(size) {
      this.privacyPage.page_size = size
      this.privacyPage.current_page = 1
      this.fetchPrivacyList()
    },
    async fetchPrivacyList() {
      this.privacyLoading = true
      this.privacyList = []
      const { list, pages } = await this.$api.getSignPrivacyList({
        page_size: this.privacyPage.page_size,
        current_page: this.privacyPage.current_page
      })
      this.$nextTick(() => {
        this.privacyList = list
      })
      if (pages) {
        this.privacyPage.total = pages.total || 0
      }
      this.privacyLoading = false
    },
    applySummary(summary, rows, pages) {
      const fallback = this.buildSummaryFromRows(rows, pages)
      const data = summary || {}
      this.summaryData = {
        active: this.firstNumber(data, ['in_contract', 'active', 'active_total', 'sign_qty', 'sign_total'], fallback.active),
        nearExpired: this.firstNumber(data, ['soon_expire', 'nearExpired', 'near_expired', 'will_expire', 'expiring_total'], fallback.nearExpired),
        expired: this.firstNumber(data, ['expire', 'expired', 'expired_total', 'overdue_total'], fallback.expired),
        fired: this.firstNumber(data, ['fired', 'fired_total', 'fired_qty', 'terminated_total'], fallback.fired),
        monthNew: this.firstNumber(data, ['add_month_num', 'monthNew', 'month_new', 'new_total', 'signing_qty'], fallback.monthNew)
      }
    },
    buildSummaryFromRows(rows, pages) {
      const currentMonth = this.currentMonthText()
      const signStatus = this.normalizeSearchList(this.searchCondition.sign_status)
      const active = rows.filter(row => this.isActive(row)).length
      const fired = rows.filter(row => this.isFired(row)).length
      const nearExpired = rows.filter(row => {
        const days = this.getDeadlineDays(row.sign_end)
        return !this.isFired(row) && days !== null && days >= 0 && days <= 30
      }).length
      const expired = rows.filter(row => {
        const days = this.getDeadlineDays(row.sign_end)
        return !this.isFired(row) && days !== null && days < 0
      }).length
      const monthNew = rows.filter(row => String(row.sign_start || '').indexOf(currentMonth) === 0).length

      return {
        active: signStatus.length === 1 && signStatus[0] === 'Y' && pages.total ? pages.total : active,
        fired: signStatus.length === 1 && signStatus[0] === 'N' && pages.total ? pages.total : fired,
        nearExpired,
        expired,
        monthNew
      }
    },
    normalizeSearchList(value) {
      if (Array.isArray(value)) {
        return value.filter(item => item !== null && item !== undefined && item !== '')
      }
      return value ? [value] : []
    },
    firstNumber(data, keys, fallback) {
      for (let i = 0; i < keys.length; i++) {
        const value = data[keys[i]]
        if (value !== undefined && value !== null && value !== '') {
          const numberValue = Number(value)
          if (!Number.isNaN(numberValue)) {
            return numberValue
          }
        }
      }
      return fallback
    },
    currentMonthText() {
      const date = new Date()
      const month = date.getMonth() + 1
      return `${date.getFullYear()}-${month < 10 ? '0' + month : month}`
    },
    parseDate(value) {
      if (!value) return null
      const date = new Date(String(value).replace(/\//g, '-'))
      if (isNaN(date.getTime())) return null
      date.setHours(0, 0, 0, 0)
      return date
    },
    formatDateText(value) {
      const date = this.parseDate(value)
      if (!date) return value || '-'
      const month = date.getMonth() + 1
      const day = date.getDate()
      return `${date.getFullYear()}年${month < 10 ? '0' + month : month}月${day < 10 ? '0' + day : day}日`
    },
    getDeadlineDays(value) {
      const date = this.parseDate(value)
      if (!date) return null
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return Math.ceil((date.getTime() - today.getTime()) / 86400000)
    },
    addMonths(date, months) {
      const result = new Date(date)
      const day = result.getDate()
      result.setDate(1)
      result.setMonth(result.getMonth() + months)
      const maxDay = new Date(result.getFullYear(), result.getMonth() + 1, 0).getDate()
      result.setDate(Math.min(day, maxDay))
      result.setHours(0, 0, 0, 0)
      return result
    },
    getDateDiffParts(startDate, endDate) {
      let years = endDate.getFullYear() - startDate.getFullYear()
      let cursor = this.addMonths(startDate, years * 12)
      if (cursor > endDate) {
        years -= 1
        cursor = this.addMonths(startDate, years * 12)
      }

      let months = (endDate.getFullYear() - cursor.getFullYear()) * 12 + endDate.getMonth() - cursor.getMonth()
      let monthCursor = this.addMonths(cursor, months)
      if (monthCursor > endDate) {
        months -= 1
        monthCursor = this.addMonths(cursor, months)
      }

      return {
        years,
        months,
        days: Math.round((endDate.getTime() - monthCursor.getTime()) / 86400000)
      }
    },
    formatDiffParts(parts) {
      const values = []
      if (parts.years) values.push(`${parts.years}年`)
      if (parts.months) values.push(`${parts.months}个月`)
      if (parts.days) values.push(`${parts.days}天`)
      return values.length ? values.join('') : '0天'
    },
    deadlineText(row) {
      const days = this.getDeadlineDays(row.sign_end)
      if (days === null || this.isFired(row)) return ''
      const signEndDate = this.parseDate(row.sign_end)
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      if (days < 0) return `已过期 ${this.formatDiffParts(this.getDateDiffParts(signEndDate, today))}`
      if (days === 0) return '今天到期'
      return `还有 ${this.formatDiffParts(this.getDateDiffParts(today, signEndDate))}到期`
    },
    deadlineClass(row) {
      const days = this.getDeadlineDays(row.sign_end)
      if (days === null) return ''
      if (days < 0) return 'is-expired'
      if (days <= 30) return 'is-near'
      if (days >= 180) return 'is-normal'
      return 'is-middle'
    },
    isActive(row) {
      return row.sign_status === 'Y' || row.sign_status_alias === '在约'
    },
    isFired(row) {
      const alias = row.sign_status_alias || ''
      return row.sign_status === 'N' || alias.indexOf('解约') > -1
    },
    statusText(row) {
      const alias = row.sign_status_alias || ''
      if (this.isFired(row)) return alias || '已解约'
      const days = this.getDeadlineDays(row.sign_end)
      if (days !== null && days >= 0 && days <= 30) return '即将到期'
      if (alias) return alias
      if (this.isActive(row)) return '在约'
      return '-'
    },
    statusClass(row) {
      const text = this.statusText(row)
      if (text.indexOf('解约') > -1) return 'is-fired'
      if (text.indexOf('即将') > -1) return 'is-near'
      if (text.indexOf('过期') > -1) return 'is-expired'
      if (text.indexOf('在约') > -1) return 'is-active'
      return ''
    },
    viewExpired() {
      this.pageData.current_page = 1
      this.getList()
    }
  }
}
</script>

<style scoped lang="scss">
.sign-management-page {
  min-height: calc(100vh - 140px);
  margin: -8px -10px 0;
  background: #f2f2f2;
  color: #001327;
}

.sign-stats-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(180px, 1fr));
  gap: 24px;
  padding: 10px 16px;
}

.stat-card {
  min-height: 92px;
  padding: 14px 22px 10px;
  border-radius: 8px;
  background: #ffffff;
  box-sizing: border-box;
}

.stat-title {
  color: #536273;
  font-size: 13px;
  line-height: 20px;
}

.stat-value {
  margin-top: 2px;
  font-size: 30px;
  line-height: 36px;
  font-weight: 400;
}

.stat-value.dark {
  color: #001327;
}

.stat-value.orange {
  color: #ff8a00;
}

.stat-value.red {
  color: #e60021;
}

.stat-note {
  margin-top: 4px;
  font-size: 12px;
}

.stat-note.green {
  color: #53b900;
}

.stat-note.orange {
  color: #ff8a00;
}

.sign-filter-panel {
  margin: 0 16px 14px;
  padding: 14px 20px;
  border-radius: 8px;
  background: #ffffff;
}

.sign-filter-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sign-filter-form {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px 8px;
  flex-wrap: wrap;
}

.filter-create-button {
  flex: 0 0 auto;
}

.sign-filter-form ::v-deep .el-form-item {
  margin: 0;
}

.sign-filter-form ::v-deep .el-input__inner {
  height: 30px;
  line-height: 30px;
  border-color: #aeb4bd;
  border-radius: 4px;
}

.sign-filter-form ::v-deep .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}

.sign-filter-form ::v-deep .el-select .el-tag {
  max-width: 66px;
}

.sign-filter-form ::v-deep .el-select__tags-text {
  display: inline-block;
  max-width: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}

.filter-status {
  width: 100px;
}

.filter-date {
  width: 240px;
}

.filter-signatory ::v-deep .el-autocomplete,
.filter-signatory ::v-deep .el-input {
  width: 140px;
}

.filter-nickname {
  width: 100px;
}

.filter-sign-type {
  width: 100px;
}

.export-hidden {
  display: none;
}

.sign-contract-table {
  background: transparent;
}

.sign-contract-table ::v-deep .el-table {
  color: #001327;
  font-size: 13px;
}

.sign-contract-table ::v-deep .el-table th.el-table__cell {
  height: 48px;
  background: #ffffff;
  color: #001327;
  font-weight: 800;
}

.sign-contract-table ::v-deep .el-table td.el-table__cell {
  height: 50px;
  padding: 0;
  background: #ffffff;
}

.sign-contract-table ::v-deep .el-table .cell {
  line-height: 20px;
}

.nickname-cell {
  font-weight: 700;
  cursor: pointer;
}

.deadline-cell {
  min-height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.deadline-note {
  margin-top: 2px;
  font-weight: 800;
  font-size: 13px;
}

.deadline-note.is-near {
  color: #e60021;
}

.status-text.is-near {
  color: #ff8a00;
}

.deadline-note.is-middle {
  color: #ff8a00;
}

.deadline-note.is-normal {
  color: #51b600;
}

.deadline-note.is-expired,
.status-text.is-expired {
  color: #666666;
}

.status-text {
  font-weight: 800;
}

.status-text.is-active {
  color: #51b600;
}

.status-text.is-fired {
  color: #e60021;
}

.tag-cell {
  display: flex;
  gap: 4px;
  justify-content: center;
  flex-wrap: wrap;
}

.action-cell {
  display: flex;
  gap: 2px;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
}

.action-cell ::v-deep .el-button {
  color: var(--primary);
}

.sign-contract-table ::v-deep .ml-page-table__footer {
  margin-top: 10px !important;
}

.sign-contract-table ::v-deep .pagination-container {
  background: transparent;
}

.sign-contract-table ::v-deep .ml-page-table__footer .el-col:first-child {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 38%;
}

.sign-contract-table ::v-deep .ml-page-table__footer .el-col:last-child {
  width: 62%;
}

.sign-footer-tips {
  margin-top: 0;
  padding: 6px 8px;
  min-width: 440px;
}

.sign-footer-tips ::v-deep .tips {
  margin-top: 0;
}

.sign-footer-tips ::v-deep .title {
  margin: 0;
  color: #001327;
  font-weight: 800;
}

.sign-footer-tips ::v-deep ol {
  margin: 4px 0 0 18px;
  padding: 0;
}

.sign-footer-tips ::v-deep li {
  margin-bottom: 0;
  color: #001327;
  font-size: 13px;
  line-height: 18px;
  font-weight: 700;
}

@media (max-width: 1280px) {
  .sign-stats-grid {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
    gap: 16px;
  }

  .sign-contract-table ::v-deep .ml-page-table__footer {
    flex-wrap: wrap;
  }

  .sign-contract-table ::v-deep .ml-page-table__footer .el-col {
    width: 100%;
  }
}

.sign-management-page {
  min-height: 0;
  height: 100%;
  max-height: calc(100vh - 116px);
  margin: 0;
  padding: 14px;
  color: #172033;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}

.sign-list-header,
.sign-filter-panel {
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
}

.sign-list-header {
  min-height: 104px;
  padding: 18px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.sign-list-title {
  min-width: 0;
}

.sign-list-kicker {
  height: 24px;
  padding: 0 10px;
  color: #ff3176;
  background: #fff0f6;
  border: 1px solid #ffd1e2;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  line-height: 24px;
}

.sign-list-title h1 {
  margin: 8px 0 4px;
  color: #172033;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0;
}

.sign-list-title p {
  margin: 0;
  color: #7a8494;
  font-size: 13px;
  line-height: 20px;
}

.sign-list-status-card {
  min-width: 220px;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #edf1f6;
  border-radius: 8px;
  box-sizing: border-box;
}

.sign-list-status-card span {
  color: #8a94a6;
  display: block;
  font-size: 12px;
  line-height: 18px;
}

.sign-list-status-card strong {
  margin-top: 4px;
  color: #263142;
  display: block;
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
}

.sign-list-status-card em {
  margin-top: 2px;
  color: #8a94a6;
  display: block;
  font-size: 12px;
  font-style: normal;
  line-height: 18px;
}

.sign-filter-panel {
  margin: 12px 0 0;
  padding: 0;
  overflow: hidden;
}

.sign-filter-row {
  padding: 14px 18px;
  display: flex;
  align-items: flex-start;
}

.sign-filter-form {
  gap: 10px;
}

.sign-filter-form ::v-deep .el-form-item {
  margin: 0;
}

.sign-filter-form ::v-deep .el-input__inner {
  height: 32px;
  line-height: 32px;
  color: #263142;
  border-color: #d9e0ea;
  border-radius: 4px;
}

.sign-filter-form ::v-deep .el-button,
.filter-create-button {
  height: 32px;
  border-radius: 4px;
}

.filter-status,
.filter-nickname,
.filter-sign-type {
  width: 132px;
}

.filter-date {
  width: 280px;
}

.filter-signatory ::v-deep .el-autocomplete,
.filter-signatory ::v-deep .el-input {
  width: 160px;
}

.sign-contract-table {
  margin-top: 12px;
  padding: 14px;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
}

.sign-contract-table ::v-deep .el-table {
  color: #263142;
  border-color: #edf1f6;
  font-size: 13px;
}

.sign-contract-table ::v-deep .el-table::before,
.sign-contract-table ::v-deep .el-table__fixed-right::before,
.sign-contract-table ::v-deep .el-table__fixed::before {
  background-color: #edf1f6;
}

.sign-contract-table ::v-deep .el-table th.el-table__cell {
  height: 46px;
  color: #475467;
  background: #f8fafc;
  border-color: #edf1f6;
  font-weight: 600;
}

.sign-contract-table ::v-deep .el-table td.el-table__cell {
  height: 48px;
  padding: 5px 0;
  color: #263142;
  background: #ffffff;
  border-color: #edf1f6;
}

.sign-contract-table ::v-deep .el-table__row:hover > td.el-table__cell {
  background: #fff7fb;
}

.nickname-cell {
  color: #ff3176;
  font-weight: 700;
}

.deadline-note {
  font-size: 12px;
  font-weight: 700;
}

.status-text {
  height: 24px;
  padding: 0 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  line-height: 24px;
}

.status-text.is-active {
  color: #188a42;
  background: #ecfdf3;
}

.status-text.is-near {
  color: #b54708;
  background: #fffaeb;
}

.status-text.is-fired {
  color: #b42318;
  background: #fef3f2;
}

.status-text.is-expired {
  color: #475467;
  background: #f2f4f7;
}

.tag-cell ::v-deep .el-tag {
  border-radius: 4px;
}

.action-cell {
  gap: 6px;
}

.action-cell ::v-deep .el-button {
  min-width: 44px;
  padding: 6px 8px;
  color: #475467;
  border-color: #d9e0ea;
  border-radius: 4px;
}

.action-cell ::v-deep .el-button:hover {
  color: #ff3176;
  border-color: #ffd1e2;
  background: #fff0f6;
}

.sign-contract-table ::v-deep .ml-page-table__footer {
  margin-top: 12px !important;
  padding-top: 12px;
  border-top: 1px solid #edf1f6;
}

.sign-contract-table ::v-deep .pagination-container {
  background: transparent;
}

.sign-contract-table ::v-deep .ml-page-table__footer .el-col:first-child {
  width: 44%;
}

.sign-contract-table ::v-deep .ml-page-table__footer .el-col:last-child {
  width: 56%;
}

.sign-footer-tips {
  min-width: 0;
  padding: 0 10px;
}

.sign-footer-tips ::v-deep .title {
  color: #172033;
  font-size: 13px;
  font-weight: 700;
}

.sign-footer-tips ::v-deep li {
  color: #667085;
  font-size: 12px;
  font-weight: 400;
}

.sign-management-page ::v-deep .el-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.sign-management-page ::v-deep .el-dialog__header {
  padding: 16px 20px;
  border-bottom: 1px solid #edf1f6;
}

//.sign-management-page ::v-deep .el-dialog__body {
//  padding: 16px 20px;
//  background: #f5f7fb;
//}

.sign-management-page ::v-deep .el-dialog__footer {
  padding: 12px 20px;
  border-top: 1px solid #edf1f6;
}
</style>
